// The PDP drawer is moved to document.body, which reconnects its product form
// and would attach a second submit handler. theme.js has already bound the
// first handler, so later submit listeners on these forms are ignored.
document.querySelectorAll("pdp-bundle-drawer form[is='product-form']").forEach((form) => {
  if (form.pdpSubmitLocked) return;
  form.pdpSubmitLocked = true;
  const nativeAdd = form.addEventListener;
  form.addEventListener = function (type, listener, options) {
    if (type === "submit") return;
    return nativeAdd.call(form, type, listener, options);
  };
});

if (!customElements.get("pdp-picker-tile")) {
  customElements.define(
    "pdp-picker-tile",
    class PickerTile extends HTMLElement {
      constructor() {
        super();
        this.handleTileClick = this.handleTileClick.bind(this);
        this.handleActionButton = this.handleActionButton.bind(this);
        this.bundlePickerDrawer = document.querySelector("pdp-bundle-drawer");
        this.actionButton = this.querySelector(".bundle-picker__tile-close");
        this.bundleAddToCart = document.querySelector("form[data-bundle] [data-product-add-to-cart-button]");
        this.drawerProductSelections = Array.from(
          document.querySelectorAll(".product-drawer__product-list")
        );
        this.associatedProductList = this.drawerProductSelections.find(
          (selection) => selection.dataset.selection === this.dataset.selection
        );
      }

      connectedCallback() {
        this.addEventListener("click", this.handleTileClick);
        this.actionButton.addEventListener("click", this.handleActionButton);
      }

      disconnectedCallback() {
        this.removeEventListener("click", this.handleTileClick);
        this.actionButton.removeEventListener("click", this.handleActionButton);
      }

      handleTileClick() {
        this.bundlePickerDrawer = this.closest("pdp-bundle-drawer") || document.querySelector("pdp-bundle-drawer");
        if (!this.bundlePickerDrawer) return;

        const panel = typeof this.bundlePickerDrawer.visiblePanel === "function"
          ? this.bundlePickerDrawer.visiblePanel()
          : this.bundlePickerDrawer;
        if (typeof this.bundlePickerDrawer.showBundleStep === "function") {
          const step = this.dataset.tile === "included-product" ? "included" : "designs";
          this.bundlePickerDrawer.showBundleStep(step);
        }
        const listRoot = typeof this.bundlePickerDrawer.visibleStepRoot === "function"
          ? this.bundlePickerDrawer.visibleStepRoot()
          : panel;
        this.drawerProductSelections = Array.from(
          listRoot.querySelectorAll(".product-drawer__product-list")
        );
        this.associatedProductList = this.drawerProductSelections.find(
          (selection) => selection.dataset.selection === this.dataset.selection
        );

        this.bundlePickerDrawer.setAttribute(
          "data-current-product",
          this.dataset.position
        );

        this.drawerProductSelections.forEach((selection) => {
          selection.setAttribute("hidden", "");
        });

        if (this.associatedProductList) {
          this.associatedProductList.removeAttribute("hidden");
        }

        const footer = typeof this.bundlePickerDrawer.visibleFooter === "function"
          ? this.bundlePickerDrawer.visibleFooter()
          : this.bundlePickerDrawer;
        footer.querySelectorAll("pdp-picker-tile").forEach((tile) => {
          tile.classList.toggle("is-active", tile === this);
        });
      }

      handleActionButton(event) {
        if (!this.actionButton.getAttribute("data-action")) {
          return;
        }

        switch (this.actionButton.getAttribute("data-action")) {
          case "remove":
            this.remove();
            (this.closest("pdp-bundle-drawer") || document.querySelector("pdp-bundle-drawer"))?.updateAddToCartPrice();
            break;
          case "replace":
            this.replaceContent();
            break;
          default:
            return;
        }
      }

      replaceContent() {
        const tileImage = this.querySelector(".bundle-picker__image");
        const titleHeading = this.querySelector(".tile__title-heading");
        const titleSubHeading = this.querySelector(".tile__title-subheading");
        const tileDrawer = this.closest("pdp-bundle-drawer");
        this.bundleAddToCart = tileDrawer?.querySelector("form[data-bundle] [data-product-add-to-cart-button]") || document.querySelector("form[data-bundle] [data-product-add-to-cart-button]");

        this.removeAttribute("aria-checked");
        const tileInput = this.querySelector("[data-bundle-input], [data-optional-input]");
        if (tileInput) tileInput.value = "";
        if (titleHeading) titleHeading.textContent = this.dataset.heading;
        if (titleSubHeading) titleSubHeading.textContent = this.dataset.subheading;
        tileImage.src = this.dataset.placeholderImage;
        if (this.bundleAddToCart) {
          const inPdpDrawer = Boolean(this.bundleAddToCart.closest("pdp-bundle-drawer")?.bundleForm);
          this.bundleAddToCart.disabled = true;
          this.bundleAddToCart.classList.remove("button--primary");
          this.bundleAddToCart.classList.add("button--ternary");
          const loaderText = this.bundleAddToCart.querySelector(".loader-button__text");
          if (loaderText && !inPdpDrawer) {
            loaderText.textContent = window.translations.bundles.chooseAllProducts;
          }
        }

        // Notify ProductDrawer that this tile position was cleared
        document.dispatchEvent(
          new CustomEvent("bundle-tile-cleared", {
            detail: { position: this.dataset.position, drawer: this.closest("pdp-bundle-drawer") },
          })
        );

        //25.04.26
        const allTiles = Array.from(
          document.querySelectorAll("[data-tile='bundle-product']")
        );
        const checkedTiles = allTiles.filter((tile) =>
          tile.hasAttribute("aria-checked")
        );
        const infoBox = document.querySelector(".bb-selected-info");
        const messageEl = document.querySelector(".bb-selected-txt p");

        if (infoBox && messageEl) {
          if (checkedTiles.length === 0) {
            infoBox.style.display = "none";
          } else {
            const lastCheckedName = checkedTiles[checkedTiles.length - 1]
              .querySelector(".tile__title-heading")?.textContent?.trim() || "";
            const totalSlots = allTiles.length;
            const isLast = checkedTiles.length >= totalSlots;
            const suffix = isLast
              ? "Your set is now ready!"
              : "Great look! Choose your next design";
            infoBox.style.display = "flex";
            messageEl.innerHTML = `<span>${lastCheckedName} successfully selected</span> ${suffix}`;
          }
        }
        //END 25.04.26
      }
    }
  );
}

// Shared filter state + logic for nail-type-filter and drawer-filter
const PdpProductListFilters = {
  // Returns the shared state object for a given product list element
  getState(productList) {
    if (!productList._filterState) {
      productList._filterState = { nailType: null, form: null };
    }
    return productList._filterState;
  },

  // Re-evaluate all wrappers against current state
  apply(productList) {
    const state = this.getState(productList);
    const allWrappers = Array.from(
      productList.querySelectorAll(".product-drawer__item-wrapper")
    );

    allWrappers.forEach((wrapper) => {
      const item = wrapper.querySelector("[data-nail-type], [data-filter]");
      if (!item) return;

      const nailType = item.dataset.nailType || null;
      const form = item.dataset.filter || null;

      const nailMatch = !state.nailType || nailType === state.nailType;
      const formMatch = !state.form || form === state.form;

      if (nailMatch && formMatch) {
        wrapper.removeAttribute("hidden");
      } else {
        wrapper.setAttribute("hidden", "");
      }
    });

    productList.querySelectorAll("drawer-design-list").forEach((list) => list.reset());
  },
};

if (!customElements.get("drawer-design-list")) {
  customElements.define(
    "drawer-design-list",
    class DrawerDesignList extends HTMLElement {
      constructor() {
        super();
        this.pageSize = 9;
        this.shown = this.pageSize;
        this.onMore = this.onMore.bind(this);
        this.clicksBound = false;
      }

      connectedCallback() {
        this.moreButton = this.querySelector(".drawer-design-list__more");
        if (!this.clicksBound && this.moreButton) {
          this.moreButton.addEventListener("click", this.onMore);
          this.clicksBound = true;
        }
        this.refresh();
      }

      disconnectedCallback() {
        this.moreButton?.removeEventListener("click", this.onMore);
        this.clicksBound = false;
      }

      onMore() {
        this.shown += this.pageSize;
        this.refresh();
      }

      reset() {
        this.shown = this.pageSize;
        this.refresh();
      }

      refresh() {
        const wrappers = Array.from(this.querySelectorAll(".product-drawer__item-wrapper"));
        const matches = wrappers.filter((wrapper) => !wrapper.hasAttribute("hidden"));

        wrappers.forEach((wrapper) => wrapper.classList.remove("is-collapsed"));
        matches.forEach((wrapper, index) => {
          if (index >= this.shown) wrapper.classList.add("is-collapsed");
        });

        if (!this.moreButton) return;

        const remaining = matches.length - this.shown;
        const next = Math.min(this.pageSize, remaining);
        if (next <= 0) {
          this.moreButton.hidden = true;
          return;
        }

        const label = this.moreButton.dataset.label || "Weitere __COUNT__ Designs laden";
        this.moreButton.hidden = false;
        this.moreButton.textContent = label.replace("__COUNT__", String(next));
      }
    }
  );
}

if (!customElements.get("pdp-drawer-filter")) {
  customElements.define(
    "pdp-drawer-filter",
    class DrawerFilter extends HTMLElement {
      constructor() {
        super();
        this.onValueClick = this.onValueClick.bind(this);
        this.clicksBound = false;
      }

      connectedCallback() {
        this.drawerProductList = this.closest(".product-drawer__product-list");
        this.filterValues = Array.from(
          this.querySelectorAll(".drawer-filter__value")
        );
        this.updateCounts();
        if (this.clicksBound) return;
        this.filterValues.forEach((value) => {
          value.addEventListener("click", this.onValueClick);
        });
        this.clicksBound = true;
      }

      disconnectedCallback() {
        if (this.filterValues) {
          this.filterValues.forEach((value) => {
            value.removeEventListener("click", this.onValueClick);
          });
        }
        this.clicksBound = false;
      }

      onValueClick(event) {
        this.handleFilterClick(event.currentTarget);
      }

      handleFilterClick(value) {
        if (value.classList.contains("active")) {
          value.classList.remove("active");
        } else {
          this.filterValues.forEach((filterValue) => {
            filterValue.classList.remove("active");
          });
          value.classList.add("active");
        }

        const activeFilter = this.filterValues.find((filterValue) =>
          filterValue.classList.contains("active")
        );

        // Update shared state and re-apply both filters
        const state = PdpProductListFilters.getState(this.drawerProductList);
        state.form = activeFilter ? activeFilter.dataset.value : null;
        PdpProductListFilters.apply(this.drawerProductList);
      }

      updateCounts() {
        if (!this.drawerProductList) return;
        const items = this.drawerProductList.querySelectorAll(".product-drawer__item");
        this.filterValues.forEach((chip) => {
          const countEl = chip.querySelector(".drawer-filter__count");
          if (!countEl) return;
          const count = Array.from(items).filter((item) => item.dataset.filter === chip.dataset.value).length;
          countEl.textContent = count;
        });
      }
    }
  );
}

if (!customElements.get("pdp-nail-type-filter")) {
  customElements.define(
    "pdp-nail-type-filter",
    class NailTypeFilter extends HTMLElement {
      constructor() {
        super();
        this.onValueClick = this.onValueClick.bind(this);
        this.clicksBound = false;
      }

      connectedCallback() {
        this.drawerProductList = this.closest(".product-drawer__product-list");
        this.filterValues = Array.from(
          this.querySelectorAll(".drawer-filter__value")
        );
        this.updateCounts();
        if (this.clicksBound) return;
        this.filterValues.forEach((value) => {
          value.addEventListener("click", this.onValueClick);
        });
        this.clicksBound = true;
      }

      disconnectedCallback() {
        this.filterValues.forEach((value) => {
          value.removeEventListener("click", this.onValueClick);
        });
        this.clicksBound = false;
      }

      onValueClick(event) {
        this.handleFilterClick(event.currentTarget);
      }

      handleFilterClick(value) {
        const isAlreadyActive = value.classList.contains("active");

        this.filterValues.forEach((v) => v.classList.remove("active"));
        if (!isAlreadyActive) {
          value.classList.add("active");
        }

        // Update shared state and re-apply both filters
        const state = PdpProductListFilters.getState(this.drawerProductList);
        state.nailType = isAlreadyActive ? null : value.dataset.value;
        PdpProductListFilters.apply(this.drawerProductList);

        // Disable drawer-filter when Toenails is selected
        const formFilter = this.drawerProductList
          ? this.drawerProductList.querySelector("pdp-drawer-filter")
          : null;
        if (formFilter) {
          if (state.nailType === "Toenail") {
            formFilter.classList.add("is-disabled");
            
            formFilter.querySelectorAll(".drawer-filter__value").forEach((v) => v.classList.remove("active"));
            state.form = null;
            PdpProductListFilters.apply(this.drawerProductList);
          } else {
            formFilter.classList.remove("is-disabled");
          }
        }
      }

      updateCounts() {
        if (!this.drawerProductList) return;
        const items = this.drawerProductList.querySelectorAll(".product-drawer__item");
        this.filterValues.forEach((chip) => {
          const countEl = chip.querySelector(".drawer-filter__count");
          if (!countEl) return;
          const count = Array.from(items).filter((item) => item.dataset.nailType === chip.dataset.value).length;
          countEl.textContent = count;
        });
      }
    }
  );
}

class PdpBundleDrawer extends DrawerContent {
  constructor() {
    super();
    this.currentProduct = null;
    this.onTileCleared = this.onTileCleared.bind(this);
  }

  connectedCallback() {
    super.connectedCallback();

    this.syncActiveBundle();

    // This is for the optionalItems
    this.optionalProductTiles = this.collectOptionalTiles();
    const optionalRoot = this.querySelector("[data-tile='optional-product']") ? this : document;
    this.optionalProductsWrapper = optionalRoot.querySelector(
      ".optional-products .bundle-picker__wrapper"
    );

    if (this.optionalProductsWrapper) {
      this.originalOptionalTile = optionalRoot
        .querySelector("[data-tile='optional-product']")
        .cloneNode(true);

      this.optionalItems = Array.from(
        this.querySelectorAll("[data-type='optional-product']")
      );
    }

    // This is for the add to cart. syncActiveBundle sets the visible bundle's button.
    if (!this.bundleAddToCart) {
      this.bundleAddToCart = document.querySelector("form[data-bundle] [data-product-add-to-cart-button]");
    }

    // This is for the quick view buttons
    this.quickViewLayer = this.querySelector(".product-drawer__quick-view");
    this.closeQuickViewLayer = this.quickViewLayer.querySelector(
      ".drawer__layer-close"
    );

    this.quickViewButtons = this.querySelectorAll(
      ".product-drawer__item-quick-view-button"
    );
    this.quickViewSlider = null;
    this.quickViewHeading = this.quickViewLayer.querySelector(
      "#QuickViewTitle"
    );
    this.quickViewAddButton =
      this.quickViewLayer.querySelector("#QuickViewAdd");

    this.addListeners();
    this.bindBundleCart();
    this.preselectCurrentProduct();
    this.updateRemainingLabel();
  }

  preselectCurrentProduct() {
    if (!this.bundleForm || !this.dataset.preselectProduct) return;

    const firstTile = this.visibleFooter().querySelector('[data-tile="bundle-product"][data-position="bundle-product-1"]');
    if (!firstTile || firstTile.hasAttribute("aria-checked")) return;

    const card = this.drawerItems.find(
      (item) => item.dataset.productId === this.dataset.preselectProduct
    );
    if (!card) return;

    this.dataset.currentProduct = firstTile.dataset.position;
    this.productTiles = this.collectBundleTiles();
    this.handleBundleProductAssignment(card);
  }

  bindBundleCart() {
    if (this.bundleCartBound) return;
    const forms = Array.from(this.querySelectorAll("form[data-bundle]"));
    if (!forms.length) return;

    this.bundleCartBound = true;
    this.bundleForms = forms;
    if (!this.bundleForm) this.bundleForm = forms[0];
    this.onBundleVariantAdded = this.onBundleVariantAdded.bind(this);
    this.onBundleCartRefresh = this.onBundleCartRefresh.bind(this);
    forms.forEach((form) => form.addEventListener("variant:added", this.onBundleVariantAdded));
  }

  onBundleVariantAdded() {
    this.open = false;
    document.documentElement.addEventListener("cart:refresh", this.onBundleCartRefresh);
  }

  onBundleCartRefresh() {
    document.documentElement.removeEventListener("cart:refresh", this.onBundleCartRefresh);
    const miniCart = document.getElementById("mini-cart");
    if (miniCart) miniCart.open = true;
  }

  markActiveTile() {
    const position = this.dataset.currentProduct;
    this.visibleFooter().querySelectorAll("pdp-picker-tile").forEach((tile) => {
      tile.classList.toggle("is-active", tile.dataset.position === position);
    });
  }

  revealFooterTile(tile) {
    if (!this.bundleForm || !tile || getComputedStyle(tile).display === "none") return;
    const scroller = tile.closest(".bundle-picker__main");
    if (!scroller || scroller.scrollWidth <= scroller.clientWidth) return;

    const tileRect = tile.getBoundingClientRect();
    const scrollerRect = scroller.getBoundingClientRect();
    const padding = 8;
    let delta = 0;
    if (tileRect.left < scrollerRect.left + padding) {
      delta = tileRect.left - scrollerRect.left - padding;
    } else if (tileRect.right > scrollerRect.right - padding) {
      delta = tileRect.right - scrollerRect.right + padding;
    }
    if (!delta) return;
    scroller.scrollTo({ left: scroller.scrollLeft + delta, behavior: "smooth" });
  }

  disconnectedCallback() {
    this.bundleForms?.forEach((form) => form.removeEventListener("variant:added", this.onBundleVariantAdded));
    document.documentElement.removeEventListener("cart:refresh", this.onBundleCartRefresh);
    this.bundleForm = null;
    this.bundleCartBound = false;
    document.removeEventListener("bundle-tile-cleared", this.onTileCleared);
    if (typeof super.disconnectedCallback === "function") {
      super.disconnectedCallback();
    }
  }

  visiblePanel() {
    return this.querySelector(".drawer-bundle-panel:not([hidden])") || this;
  }

  visibleFooter() {
    return this.querySelector(".drawer-bundle-footer:not([hidden])") || this;
  }

  visibleStepRoot() {
    const panel = this.visiblePanel();
    return panel.querySelector(".drawer-bundle-step:not([hidden])") || panel;
  }

  activeStep() {
    const selected = this.visiblePanel().querySelector(".drawer-bundle-steps [data-bundle-step].is-selected");
    return selected?.dataset.bundleStep || "designs";
  }

  showBundleStep(step) {
    const panel = this.visiblePanel();
    if (!panel.querySelector(".drawer-bundle-steps")) return;
    panel.querySelectorAll(".drawer-bundle-step").forEach((el) => {
      el.toggleAttribute("hidden", el.dataset.bundleStep !== step);
    });
    panel.querySelectorAll(".drawer-bundle-steps [data-bundle-step]").forEach((button) => {
      button.classList.toggle("is-selected", button.dataset.bundleStep === step);
    });
    const footer = panel.dataset.bundlePanel
      ? this.querySelector(`.drawer-bundle-footer[data-bundle-panel="${panel.dataset.bundlePanel}"]`)
      : this.visibleFooter();
    if (footer?.dataset) footer.dataset.activeStep = step;
  }

  setBundleStep(step) {
    this.showBundleStep(step);
    this.syncActiveBundle();
    const activeTile = this.activeTiles().find((tile) => tile.dataset.position === this.dataset.currentProduct);
    const lists = this.visibleStepRoot().querySelectorAll(".product-drawer__product-list");
    if (activeTile) {
      lists.forEach((list) => {
        list.toggleAttribute("hidden", list.dataset.selection !== activeTile.dataset.selection);
      });
    }
    this.markActiveTile();
    this.updateRemainingLabel();
    this.updateSlotAvailability();
    this.updateDrawerCheckmarks();
    this.refreshTileScrolls();
  }

  ensureBundleSelection() {
    const handle = this.visiblePanel().dataset.bundlePanel || "";
    const key = `${handle}:${this.activeStep()}`;
    if (!this.selectionsByBundle) this.selectionsByBundle = {};
    if (!this.selectionsByBundle[key]) this.selectionsByBundle[key] = {};
    this.selectedVariants = this.selectionsByBundle[key];
  }

  syncActiveBundle() {
    this.ensureBundleSelection();
    const footer = this.visibleFooter();
    const panel = this.visiblePanel();
    this.bundleForm = footer.querySelector("form[data-bundle]") || this.querySelector("form[data-bundle]");
    const drawerButton = footer.querySelector("[data-product-add-to-cart-button]");
    this.bundleAddToCart = drawerButton || this.bundleAddToCart || document.getElementById("AddToCart");
    const stepRoot = panel.querySelector(".drawer-bundle-step:not([hidden])") || panel;
    this.drawerItems = Array.from(stepRoot.querySelectorAll("[data-type='drawer-product']"));
    this.productTiles = this.collectBundleTiles();
    this.optionalProductTiles = this.collectOptionalTiles();
    const activeTiles = this.activeTiles();
    const activeTile = activeTiles.find((tile) => tile.classList.contains("is-active"))
      || activeTiles.find((tile) => !tile.hasAttribute("aria-checked"))
      || activeTiles[0];
    if (activeTile) this.dataset.currentProduct = activeTile.dataset.position;
  }

  activateBundlePanel() {
    this.syncActiveBundle();
    this.preselectCurrentProduct();
    this.updateRemainingLabel();
    this.updateSlotAvailability();
    this.updateDrawerCheckmarks();
    this.refreshTileScrolls();
  }

  refreshTileScrolls() {
    this.querySelectorAll("bundle-tile-scroll").forEach((bar) => bar.update());
  }

  collectBundleTiles() {
    const footer = this.querySelector(".drawer-bundle-footer:not([hidden])");
    const root = footer || this;
    const scoped = root.querySelectorAll("[data-tile='bundle-product']");
    if (scoped.length) return Array.from(scoped);
    return Array.from(document.querySelectorAll("[data-tile='bundle-product']"));
  }

  collectIncludedTiles() {
    const footer = this.querySelector(".drawer-bundle-footer:not([hidden])");
    const root = footer || this;
    return Array.from(root.querySelectorAll("[data-tile='included-product']"));
  }

  activeTiles() {
    return this.activeStep() === "included" ? this.collectIncludedTiles() : this.collectBundleTiles();
  }

  collectOptionalTiles() {
    const footer = this.querySelector(".drawer-bundle-footer:not([hidden])");
    const root = footer || this;
    const scoped = root.querySelectorAll("[data-tile='optional-product']");
    if (scoped.length) return Array.from(scoped);
    return Array.from(document.querySelectorAll("[data-tile='optional-product']"));
  }

  onTileCleared(event) {
    if (event.detail?.drawer && event.detail.drawer !== this) return;
    this.ensureBundleSelection();
    this.updateRemainingLabel();
    if (!this.selectedVariants) return;
    const clearedPosition = event.detail.position;
    for (const [variantId, pos] of Object.entries(this.selectedVariants)) {
      if (pos === clearedPosition) {
        delete this.selectedVariants[variantId];
      }
    }
    this.updateDrawerCheckmarks();
    this.updateSlotAvailability();
  }

  async attributeChangedCallback(name, oldValue, newValue) {
    super.attributeChangedCallback(name, oldValue, newValue);
    if (name === "open" && this.open) {
      this.preselectCurrentProduct();
      this.updateRemainingLabel();
      this.refreshTileScrolls();
      const drawerContent = this.querySelector(".drawer__content");
      if (drawerContent) {
        drawerContent.scrollTop = 0;
      }
      const items = Array.from(
          this.querySelectorAll(".product-drawer__item:not([hidden]")
        ),
        effects = [];
      items.forEach((item) => (item.style.opacity = 0));
      effects.push(
        new ParallelEffect(
          items.map((item, index) => {
            return new CustomKeyframeEffect(
              item,
              {
                opacity: [0, 1],
                transform: ["translateX(40px)", "translateX(0)"],
              },
              {
                duration: 200, // Further reduced duration
                delay:
                  200 + 60 * index - Math.min(1 * index * index, 60 * index), // Reduced delay calculation
                easing: "cubic-bezier(0.25, 1, 0.5, 1)", // You can also consider simpler easing, like "ease-out"
              }
            );
          })
        )
      );
      let animation = new CustomAnimation(new ParallelEffect(effects));
      animation.play();
    }
  }

  async addListeners() {
    this.closeQuickViewLayer.addEventListener(
      "click",
      this.toggleQuickViewLayer.bind(this)
    );

    this.quickViewButtons.forEach((button) => {
      button.addEventListener("click", this.handleQuickView.bind(this));
    });
    this.quickViewAddButton.addEventListener("click", (event) => {
      this.handleBundleProductAssignment(this.quickViewAddButton);
      this.handleOptionalProductAssignment(this.quickViewAddButton);
      this.toggleQuickViewLayer();
      if (this.bundleForm) event.stopImmediatePropagation();
    });

    document.addEventListener("bundle-tile-cleared", this.onTileCleared);

    this.querySelectorAll("[data-type='drawer-product']").forEach((product) => {
      if (product.dataset.bundleClickBound) return;
      product.dataset.bundleClickBound = "true";
      product.addEventListener("click", (event) => {
        if (event.target.closest(".product-drawer__item-quick-view-button")) return;
        this.syncActiveBundle();
        if (this.bundleForm) event.stopImmediatePropagation();
        this.handleBundleProductAssignment(product, event);
      });
    });

    if (
      !this.optionalItems ||
      !this.optionalItems.length ||
      !this.optionalProductTiles.length
    ) {
      return;
    }

    this.optionalItems.forEach((product) => {
      product.addEventListener("click", () => {
        this.handleOptionalProductAssignment(product);
      });
    });
  }
/* OLD Logic for product selection and drawer close
  handleBundleProductAssignment(product) {
    this.currentProduct = this.dataset.currentProduct;

    const currentTile = this.productTiles.find((tile) => {
      return tile.dataset.position === this.currentProduct;
    });

    if (!currentTile) {
      console.warn(`No tile found for position: ${this.currentProduct}`);
      return;
    }

    const image = product.dataset.image;
    const currentTileImage = currentTile.querySelector(".bundle-picker__image");
    const currentTileHeading = currentTile.querySelector(
      ".tile__title-heading"
    );
    const currentTileSubHeading = currentTile.querySelector(
      ".tile__title-subheading"
    );
    const currentTileVariantId = currentTile.querySelector(
      `#${this.currentProduct}`
    );

    // Assigning values only if elements exist
    if (image && currentTileImage) {
      currentTileImage.src = image;
    }

    if (product.dataset.variantId && currentTileVariantId) {
      currentTileVariantId.value = product.dataset.variantId;
    }

    if (product.dataset.heading && currentTileHeading) {
      currentTileHeading.textContent = product.dataset.heading;
    }

    if (product.dataset.subheading && currentTileSubHeading) {
      currentTileSubHeading.textContent = product.dataset.subheading;
    }

    currentTile.setAttribute("aria-checked", "true");

    // Refresh bundleTiles in case the DOM has changed
    this.productTiles = Array.from(
      document.querySelectorAll("[data-tile='bundle-product']")
    );

    if (this.productTiles.every((tile) => tile.hasAttribute("aria-checked"))) {
      if (this.bundleAddToCart) {
        this.bundleAddToCart.disabled = false;
        this.bundleAddToCart.classList.add("button--primary");
        this.bundleAddToCart.classList.remove("button--ternary");

        const loaderButtonText = this.bundleAddToCart.querySelector(
          ".loader-button__text"
        );
        if (loaderButtonText) {
          const addToCartText =
            window.translations?.product?.form?.addToCart || "Add to Cart";
          loaderButtonText.textContent = addToCartText;
        }

        this.updateAddToCartPrice();
      }
    }
    this.updateSelectedInfo(product.dataset.heading);
  }*/

  handleBundleProductAssignment(product, event) {
    this.ensureBundleSelection();
    const variantId = product.dataset.variantId;
    const selectedPosition = variantId && this.selectedVariants?.[variantId];
    const clickedQuickView = event?.target?.closest(".product-drawer__item-quick-view-button");

    if (this.bundleForm && selectedPosition && !clickedQuickView) {
      event?.stopImmediatePropagation();
      const tile = this.visibleFooter().querySelector(`pdp-picker-tile[data-position="${selectedPosition}"]`);
      tile?.replaceContent();
      if (!tile) return;

      this.dataset.currentProduct = tile.dataset.position;
      this.visibleStepRoot().querySelectorAll(".product-drawer__product-list").forEach((selection) => {
        selection.toggleAttribute("hidden", selection.dataset.selection !== tile.dataset.selection);
      });
      this.markActiveTile();
      return;
    }

    this.currentProduct = this.dataset.currentProduct;
    const assignmentTiles = this.activeTiles();

    const currentTile = assignmentTiles.find((tile) => {
      return tile.dataset.position === this.currentProduct;
    });

    if (!currentTile) {
      console.warn(`No tile found for position: ${this.currentProduct}`);
      return;
    }

    const image = product.dataset.image;
    const currentTileImage = currentTile.querySelector(".bundle-picker__image");
    const currentTileHeading = currentTile.querySelector(
      ".tile__title-heading"
    );
    const currentTileSubHeading = currentTile.querySelector(
      ".tile__title-subheading"
    );
    const currentTileVariantId = currentTile.querySelector(
      `#${this.currentProduct}`
    );

    // Assigning values only if elements exist
    if (image && currentTileImage) {
      currentTileImage.src = image;
    }

    if (product.dataset.variantId && currentTileVariantId) {
      currentTileVariantId.value = product.dataset.variantId;
    }

    if (product.dataset.heading && currentTileHeading) {
      currentTileHeading.textContent = product.dataset.heading;
    }

    if (product.dataset.subheading && currentTileSubHeading) {
      currentTileSubHeading.textContent = product.dataset.subheading;
    }

    currentTile.setAttribute("aria-checked", "true");
    this.revealFooterTile(currentTile);

    // render checkmarks
    if (!this.selectedVariants) this.selectedVariants = {};
    
    for (const [variantId, pos] of Object.entries(this.selectedVariants)) {
      if (pos === this.currentProduct) delete this.selectedVariants[variantId];
    }
    if (product.dataset.variantId) {
      this.selectedVariants[product.dataset.variantId] = this.currentProduct;
    }
    this.updateDrawerCheckmarks();

    this.productTiles = this.collectBundleTiles();
    const stepTiles = this.activeTiles();
    const stepFilled = stepTiles.length > 0 && stepTiles.every((tile) => tile.hasAttribute("aria-checked"));

    if (stepFilled) {
      if (this.bundleForm && event) event.stopImmediatePropagation();
      this.advanceBundleStep();
    } else {
      if (event) {
        event.stopImmediatePropagation();
      }
      const nextEmptyTile = stepTiles.find(
        (tile) => !tile.hasAttribute("aria-checked")
      );

      if (nextEmptyTile) {
        this.dataset.currentProduct = nextEmptyTile.dataset.position;

        const drawerProductSelections = Array.from(
          this.visibleStepRoot().querySelectorAll(".product-drawer__product-list")
        );
        drawerProductSelections.forEach((selection) => {
          selection.setAttribute("hidden", "");
        });
        const nextList = drawerProductSelections.find(
          (selection) =>
            selection.dataset.selection === nextEmptyTile.dataset.selection
        );
        if (nextList) {
          nextList.removeAttribute("hidden");
        }
        this.markActiveTile();
      }
      this.updateRemainingLabel();
    }

    this.updateSlotAvailability();
    this.updateSelectedInfo(product.dataset.heading);
  }

  slotsAreFull(tiles) {
    return tiles.length > 0 && tiles.every((tile) => tile.hasAttribute("aria-checked"));
  }

  advanceBundleStep() {
    const designs = this.collectBundleTiles();
    const included = this.collectIncludedTiles();
    const designsDone = this.slotsAreFull(designs);
    const includedDone = included.length === 0 || this.slotsAreFull(included);

    if (designsDone && includedDone) {
      this.enableBundleAddToCart();
      return;
    }

    if (designsDone && included.length && !includedDone && this.activeStep() !== "included") {
      this.setBundleStep("included");
      return;
    }

    if (!designsDone && includedDone && this.activeStep() !== "designs") {
      this.setBundleStep("designs");
      return;
    }

    this.updateRemainingLabel();
  }

  enableBundleAddToCart() {
    if (!this.bundleAddToCart) return;
    this.bundleAddToCart.disabled = false;
    this.bundleAddToCart.classList.add("button--primary");
    this.bundleAddToCart.classList.remove("button--ternary");

    const loaderButtonText = this.bundleAddToCart.querySelector(".loader-button__text");
    if (loaderButtonText) {
      loaderButtonText.textContent = window.translations?.product?.form?.addToCart || "Add to Cart";
    }
    this.updateAddToCartPrice();
  }

  updateRemainingLabel() {
    if (!this.bundleForm || !this.bundleAddToCart) return;

    const designRemaining = this.collectBundleTiles().filter((tile) => !tile.hasAttribute("aria-checked")).length;
    const includedRemaining = this.collectIncludedTiles().filter((tile) => !tile.hasAttribute("aria-checked")).length;
    const bundles = window.translations?.bundles || {};
    let remaining = 0;
    let template = "";

    if (designRemaining > 0) {
      remaining = designRemaining;
      template = remaining === 1 ? bundles.chooseRemainingOne : bundles.chooseRemainingOther;
    } else if (includedRemaining > 0) {
      remaining = includedRemaining;
      template = remaining === 1 ? bundles.chooseIncludedOne : bundles.chooseIncludedOther;
    }

    if (!remaining || !template) return;

    const loaderText = this.bundleAddToCart.querySelector(".loader-button__text");
    if (!loaderText) return;

    this.bundleAddToCart.disabled = true;
    this.bundleAddToCart.classList.add("button--ternary");
    this.bundleAddToCart.classList.remove("button--primary");
    loaderText.textContent = template.replace(/__COUNT__/g, remaining);
  }

  updateSlotAvailability() {
    if (!this.bundleForm) return;
    const panel = this.visiblePanel();
    panel.querySelectorAll(".drawer-bundle-step").forEach((step) => {
      const tiles = step.dataset.bundleStep === "included" ? this.collectIncludedTiles() : this.collectBundleTiles();
      step.classList.toggle("is-step-full", this.slotsAreFull(tiles));
    });
    const included = this.collectIncludedTiles();
    const complete = this.slotsAreFull(this.collectBundleTiles()) && (included.length === 0 || this.slotsAreFull(included));
    this.classList.toggle("is-full", complete);
  }

  updateAddToCartPrice() {
    if (!this.bundleAddToCart || this.bundleAddToCart.disabled) return;
    if (typeof formatMoney !== "function") return;

    const loaderButtonText = this.bundleAddToCart.querySelector(
      ".loader-button__text"
    );
    if (!loaderButtonText) return;

    const bundleForm =
      this.bundleAddToCart.closest("form[data-bundle]") ||
      document.querySelector("form[data-bundle]");
    if (!bundleForm) return;

    // The set has a fixed price (data-price on the form), it is NOT the sum of
    // the selected styles — those are discounted down to the set price in cart.
    const bundlePrice = parseFloat(bundleForm.dataset.price || 0);
    if (!bundlePrice) return;

    let totalCents = Math.round(bundlePrice * 100);

    // Optional add-ons are charged on top, minus their bundle discount.
    const optionalDiscount = parseFloat(bundleForm.dataset.optionalDiscount || 0);
    document
      .querySelectorAll("input[data-optional-input]")
      .forEach((input) => {
        if (!input.value) return;
        const price = parseFloat(input.dataset.price || 0);
        if (!price) return;
        totalCents += Math.round(price * 100 * (1 - optionalDiscount / 100));
      });

    const addToCartText =
      window.translations?.product?.form?.addToCart || "Add to Cart";

    // Same markup as the standard product template so the shared
    // .product-form__add-button-* styles apply (see custom.css).
    loaderButtonText.textContent = "";

    const label = document.createElement("span");
    label.className = "product-form__add-button-label";
    label.textContent = addToCartText;

    const separator = document.createElement("span");
    separator.className = "product-form__add-button-separator";
    separator.setAttribute("aria-hidden", "true");
    separator.textContent = "·";

    const price = document.createElement("span");
    price.className = "product-form__add-button-price";
    price.innerHTML = formatMoney(totalCents);

    loaderButtonText.append(label, separator, price);
  }

  //checkmark
  updateDrawerCheckmarks() {
    if (!document.getElementById("drawer-checkmark-styles")) {
      const style = document.createElement("style");
      style.id = "drawer-checkmark-styles";
      style.textContent = `
        .product-drawer__item { position: relative; }
        .drawer-selected-check {
          display: none;
          position: absolute;
          top: 8px;
          right: 8px;
          width: 23px;
          height: 23px;
          background: #ffffff;
          border-radius: 50%;
          align-items: center;
          justify-content: center;
          pointer-events: none;
          z-index: 2;
        }
        .product-drawer__item.is-selected .drawer-selected-check {
          display: flex;
        }
        .drawer-selected-check svg {
          width: 13px;
          height: 13px;
          fill: none;
          stroke: #ab6a7d;
          stroke-width: 2.5;
          stroke-linecap: round;
          stroke-linejoin: round;
        }
      `;
      document.head.appendChild(style);
    }

    this.drawerItems.forEach((item) => {
      if (!item.querySelector(".drawer-selected-check")) {
        const badge = document.createElement("span");
        badge.className = "drawer-selected-check";
        badge.innerHTML = `<svg viewBox="0 0 12 12"><polyline points="2,6 5,9 10,3"/></svg>`;
        item.appendChild(badge);
      }
      const variantId = item.dataset.variantId;
      if (variantId && this.selectedVariants && this.selectedVariants[variantId]) {
        item.classList.add("is-selected");
      } else {
        item.classList.remove("is-selected");
      }
    });
  }

  updateSelectedInfo(productName) {
    const infoBox = document.querySelector(".bb-selected-info");
    const messageEl = document.querySelector(".bb-selected-txt p");
    if (!infoBox || !messageEl) return;

    const totalSlots = this.productTiles.length;
    const filledSlots = this.productTiles.filter((tile) =>
      tile.hasAttribute("aria-checked")
    ).length;

    if (filledSlots === 0) {
      infoBox.style.display = "none";
      return;
    }

    infoBox.style.display = "flex";

    const isLast = filledSlots >= totalSlots;
    const suffix = isLast
      ? "Gute Wahl! Dein Set ist jetzt komplett!"
      : "Gute Wahl! Wähle dein nächstes Design";

    messageEl.innerHTML = `<span>${productName} hinzugefügt</span> ${suffix}`;
  }

  handleOptionalProductAssignment(product) {
    this.currentProduct = this.dataset.currentProduct;
    this.optionalProductTiles = Array.from(
      document.querySelectorAll("[data-tile='optional-product']")
    );

    const currentTile = this.optionalProductTiles.find((tile) => {
      return tile.dataset.position === this.currentProduct;
    });

    if (!currentTile) {
      console.warn(`No tile found for position: ${this.currentProduct}`);
      return;
    }

    const image = product.dataset.image;
    const currentTileImage = currentTile.querySelector(".bundle-picker__image");
    const currentTileHeading = currentTile.querySelector(
      ".tile__title-heading"
    );
    const currentTileSubHeading = currentTile.querySelector(
      ".tile__title-subheading"
    );
    const currentTileVariantId = currentTile.querySelector(
      `#${this.currentProduct}`
    );

    if (image && currentTileImage) {
      currentTileImage.src = image;
    }

    if (product.dataset.variantId && currentTileVariantId) {
      currentTileVariantId.value = product.dataset.variantId;
    }

    if (product.dataset.price && currentTileVariantId) {
      currentTileVariantId.setAttribute("data-price", product.dataset.price);
    }

    if (product.dataset.heading && currentTileHeading) {
      currentTileHeading.textContent = product.dataset.heading;
    }

    if (product.dataset.subheading && currentTileSubHeading) {
      currentTileSubHeading.textContent = product.dataset.subheading;
    }

    this.updateAddToCartPrice();

    if (currentTile.getAttribute("aria-checked") === "true") {
      return;
    }

    currentTile.setAttribute("aria-checked", "true");

    const newOptionalTile = this.originalOptionalTile.cloneNode(true);
    newOptionalTile.setAttribute(
      "data-position",
      `optional-product-${this.getNextFreeNumber(this.optionalProductTiles)}`
    );
    newOptionalTile.querySelector(
      "input"
    ).id = `optional-product-${this.getNextFreeNumber(this.optionalProductTiles)}`;
    this.optionalProductsWrapper.appendChild(newOptionalTile);

    this.updateAddToCartPrice();
  }

  toggleQuickViewLayer() {
    if (this.quickViewLayer.hasAttribute("open")) {
      this.quickViewLayer.removeAttribute("open");
    } else {
      this.quickViewLayer.setAttribute("open", "");
    }
  }

  handleQuickView(event) {
    const quickViewData = event.target
      .closest(".product-drawer__item-wrapper")
      .querySelector(".product-drawer__item");

    const images = quickViewData
      ? JSON.parse(quickViewData.dataset.images)
      : null;
    const slides = images.map((image) => {
      return `
        <div class="swiper-slide">
          <img src="${image}">
        </div>
      `;
    });
    this.quickViewSlider = this.querySelector("swiper-element").swiperInstance;
    this.quickViewSlider.removeAllSlides();
    this.quickViewSlider.appendSlide(slides);
    this.quickViewSlider.update();
    this.quickViewSlider.slideTo(0);
    this.quickViewHeading.textContent = quickViewData.dataset.heading;
    this.quickViewAddButton.setAttribute(
      "data-image",
      quickViewData.dataset.image
    );
    this.quickViewAddButton.setAttribute(
      "data-variant-id",
      quickViewData.dataset.variantId
    );
    this.quickViewAddButton.setAttribute(
      "data-heading",
      quickViewData.dataset.heading
    );
    this.quickViewAddButton.setAttribute(
      "data-subheading",
      quickViewData.dataset.subheading
    );

    this.toggleQuickViewLayer();
  }

  getNextFreeNumber(optionalTiles) {
    const usedNumbers = Array.from(optionalTiles)
      .map((tile) => {
        const match = tile
          .getAttribute("data-position")
          ?.match(/optional-product-(\d+)/);
        return match ? parseInt(match[1], 10) : null;
      })
      .filter((num) => num !== null);
    usedNumbers.sort((a, b) => a - b);
    let nextNumber = 1;
    for (const num of usedNumbers) {
      if (num === nextNumber) {
        nextNumber++;
      } else {
        break;
      }
    }

    return nextNumber;
  }
}

window.customElements.define("pdp-bundle-drawer", PdpBundleDrawer);

class DrawerBundleSwitch extends HTMLElement {
  constructor() {
    super();
    this.onChoiceClick = this.onChoiceClick.bind(this);
    this.clicksBound = false;
  }

  connectedCallback() {
    if (this.clicksBound) return;
    this.addEventListener("click", this.onChoiceClick);
    this.clicksBound = true;
  }

  disconnectedCallback() {
    this.removeEventListener("click", this.onChoiceClick);
    this.clicksBound = false;
  }

  onChoiceClick(event) {
    const button = event.target.closest("[data-bundle-choice]");
    if (!button || button.classList.contains("is-selected")) return;

    const drawer = this.closest("pdp-bundle-drawer");
    if (!drawer) return;

    const handle = button.dataset.bundleChoice;
    this.querySelectorAll("[data-bundle-choice]").forEach((option) => {
      option.classList.toggle("is-selected", option === button);
    });
    drawer.querySelectorAll("[data-bundle-panel]").forEach((panel) => {
      panel.toggleAttribute("hidden", panel.dataset.bundlePanel !== handle);
    });

    const title = drawer.querySelector(".drawer__header .drawer__title");
    if (title && button.dataset.bundleTitle) {
      const name = title.querySelector(".drawer__title-name");
      const price = title.querySelector(".drawer__title-price");
      if (name && price) {
        name.textContent = button.dataset.bundleTitle;
        price.textContent = button.dataset.bundlePrice || "";
      } else {
        title.textContent = button.dataset.bundleTitle;
      }
    }
    drawer.activateBundlePanel();
  }
}

window.customElements.define("drawer-bundle-switch", DrawerBundleSwitch);

class BundleTileScroll extends HTMLElement {
  constructor() {
    super();
    this.update = this.update.bind(this);
    this.bound = false;
  }

  connectedCallback() {
    this.scroller = this.previousElementSibling;
    this.thumb = this.querySelector(".bundle-picker__scrollbar-thumb");
    if (!this.scroller || !this.thumb || this.bound) return;

    this.bound = true;
    this.scroller.addEventListener("scroll", this.update, { passive: true });
    this.resizeObserver = new ResizeObserver(this.update);
    this.resizeObserver.observe(this.scroller);
    const footer = this.closest(".drawer-bundle-footer");
    if (footer) {
      this.footerObserver = new MutationObserver(this.update);
      this.footerObserver.observe(footer, { attributes: true, attributeFilter: ["data-active-step", "hidden"] });
    }
    this.update();
  }

  disconnectedCallback() {
    this.scroller?.removeEventListener("scroll", this.update);
    this.resizeObserver?.disconnect();
    this.footerObserver?.disconnect();
    this.bound = false;
  }

  update() {
    cancelAnimationFrame(this.frame);
    this.frame = requestAnimationFrame(() => this.positionThumb());
  }

  positionThumb() {
    if (!this.scroller || !this.thumb || !this.scroller.clientWidth) return;
    const maxScroll = this.scroller.scrollWidth - this.scroller.clientWidth;
    const canScroll = maxScroll > 1;
    this.hidden = !canScroll;
    if (!canScroll) return;

    const trackWidth = this.scroller.clientWidth;
    if (!trackWidth) return;
    const thumbWidth = Math.max(28, (this.scroller.clientWidth / this.scroller.scrollWidth) * trackWidth);
    const left = (this.scroller.scrollLeft / maxScroll) * (trackWidth - thumbWidth);

    this.thumb.style.width = `${thumbWidth}px`;
    this.thumb.style.transform = `translateX(${left}px)`;
  }
}

window.customElements.define("bundle-tile-scroll", BundleTileScroll);

class DrawerBundleSteps extends HTMLElement {
  constructor() {
    super();
    this.onStepClick = this.onStepClick.bind(this);
    this.clicksBound = false;
  }

  connectedCallback() {
    if (this.clicksBound) return;
    this.addEventListener("click", this.onStepClick);
    this.clicksBound = true;
  }

  disconnectedCallback() {
    this.removeEventListener("click", this.onStepClick);
    this.clicksBound = false;
  }

  onStepClick(event) {
    const button = event.target.closest("[data-bundle-step]");
    if (!button || button.classList.contains("is-selected")) return;
    this.closest("pdp-bundle-drawer")?.setBundleStep(button.dataset.bundleStep);
  }
}

window.customElements.define("drawer-bundle-steps", DrawerBundleSteps);

class PdpBundlePicker extends HTMLElement {
  connectedCallback() {
    if (this.pageButtons) return;

    this.singleButton = this.querySelector('[data-pdp-choice="single"]');
    this.bundleButtons = Array.from(this.querySelectorAll('[data-pdp-choice="bundle"]'));
    this.drawers = this.bundleButtons
      .map((button) => document.getElementById(button.dataset.drawerId))
      .filter(Boolean);
    this.drawer = null;
    this.pageButtons = ["AddToCart", "StickyAddToCart"]
      .map((id) => document.getElementById(id))
      .filter(Boolean);
    this.originalLabels = new Map();

    this.onPageButtonClick = this.onPageButtonClick.bind(this);
    this.onBundleClick = this.onBundleClick.bind(this);
    this.onSingleClick = this.onSingleClick.bind(this);
    this.onDrawerClose = this.onDrawerClose.bind(this);

    this.pageButtons.forEach((button) => {
      const text = button.querySelector(".loader-button__text");
      this.originalLabels.set(button, text ? text.innerHTML : button.innerHTML);
      button.addEventListener("click", this.onPageButtonClick, true);
    });

    this.bundleButtons.forEach((button) => {
      button.addEventListener("click", this.onBundleClick);
    });
    this.singleButton?.addEventListener("click", this.onSingleClick);
    this.drawers.forEach((drawer) => {
      drawer.addEventListener("openable-element:close", this.onDrawerClose);
    });
  }

  disconnectedCallback() {
    this.pageButtons?.forEach((button) => {
      button.removeEventListener("click", this.onPageButtonClick, true);
    });
    this.bundleButtons?.forEach((button) => {
      button.removeEventListener("click", this.onBundleClick);
    });
    this.singleButton?.removeEventListener("click", this.onSingleClick);
    this.drawers?.forEach((drawer) => {
      drawer.removeEventListener("openable-element:close", this.onDrawerClose);
    });
    this.pageButtons = null;
  }

  onPageButtonClick(event) {
    if (this.dataset.choice !== "bundle" || !this.drawer) return;
    event.preventDefault();
    event.stopPropagation();
    this.drawer.open = true;
  }

  onBundleClick(event) {
    const button = event.currentTarget;
    const drawer = document.getElementById(button.dataset.drawerId);
    if (!drawer) return;

    this.dataset.choice = "bundle";
    this.drawer = drawer;
    this.singleButton?.classList.remove("is-selected");
    this.bundleButtons.forEach((item) => {
      item.classList.toggle("is-selected", item === button);
    });
    this.drawers.forEach((other) => {
      if (other !== drawer && other.open) other.open = false;
    });
    this.pageButtons.forEach((pageButton) => {
      pageButton.type = "button";
    });
    this.setPageButtonLabel(this.dataset.chooseLabel);
    drawer.open = true;
  }

  onSingleClick() {
    this.dataset.choice = "single";
    this.drawer = null;
    this.bundleButtons.forEach((button) => {
      button.classList.remove("is-selected");
    });
    this.singleButton?.classList.add("is-selected");
    this.restorePageButtonLabels();
    this.drawers.forEach((drawer) => {
      if (drawer.open) drawer.open = false;
    });
  }

  onDrawerClose() {
    if (this.dataset.choice === "bundle") {
      this.setPageButtonLabel(this.dataset.chooseLabel);
    }
  }

  setPageButtonLabel(label) {
    this.pageButtons.forEach((button) => {
      const text = button.querySelector(".loader-button__text");
      if (text) text.textContent = label;
      else button.textContent = label;
    });
  }

  restorePageButtonLabels() {
    this.pageButtons.forEach((button) => {
      const text = button.querySelector(".loader-button__text");
      const html = this.originalLabels.get(button);
      if (text) text.innerHTML = html;
      else button.innerHTML = html;
      button.type = "submit";
    });
  }
}

window.customElements.define("pdp-bundle-picker", PdpBundlePicker);
